import React, { useEffect } from 'react';
import { Calendar, Phone } from 'lucide-react';

export const SimplePracticeButton = ({ 
  variant = 'appointment', 
  size = 'default',
  className = '',
  fullWidth = false 
}) => {
  useEffect(() => {
    // Load SimplePractice script after component mounts
    const script = document.createElement('script');
    script.src = 'https://widget-cdn.simplepractice.com/assets/integration-1.0.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  const sizeClasses = {
    default: 'px-6 py-3 text-sm',
    lg: 'px-8 py-6 text-lg'
  };

  const variants = {
    appointment: {
      text: 'Book Your Appointment',
      icon: Calendar,
      classes: 'bg-teal-600 hover:bg-teal-700 text-white'
    },
    consultation: {
      text: 'Schedule Free Consultation',
      icon: Phone,
      classes: 'bg-white text-teal-600 border-2 border-teal-600 hover:bg-teal-50'
    }
  };

  const selected = variants[variant];
  const Icon = selected.icon;

  return (
    <div className={`spwidget-button-wrapper ${fullWidth ? 'w-full' : ''}`}>
      <a
        href={process.env.REACT_APP_SIMPLEPRACTICE_URL || "https://mhcmaui.clientsecure.me"}
        className={`
          spwidget-button
          inline-flex items-center justify-center
          ${sizeClasses[size]}
          font-semibold rounded-md
          transition-all duration-200
          shadow-lg hover:shadow-xl hover:-translate-y-0.5
          ${selected.classes}
          ${fullWidth ? 'w-full' : ''}
          ${className}
        `.trim().replace(/\s+/g, ' ')}
        data-spwidget-scope-id="6e4e7840-50a0-4ceb-985f-7a694500c64b"
        data-spwidget-scope-uri="mhcmaui"
        data-spwidget-application-id="7c72cb9f9a9b913654bb89d6c7b4e71a77911b30192051da35384b4d0c6d505b"
        data-spwidget-type="OAR"
        data-spwidget-scope-global
        data-spwidget-autobind
      >
        <Icon size={size === 'lg' ? 20 : 16} className="mr-2" />
        {selected.text}
      </a>
    </div>
  );
};

// Add SimplePractice styles to App.css or index.css
export const simplePracticeStyles = `
.spwidget-button-wrapper {
  text-align: center;
}

.spwidget-button {
  text-decoration: none;
  cursor: pointer;
}

.spwidget-button:hover {
  text-decoration: none;
}

.spwidget-button:active {
  box-shadow: 0 1px 3px rgba(0, 0, 0, .15) inset;
}
`;

